/** Display/new-selection names only. Never rewrites persisted staff or roster data. */
export const normalizeStaffRole = (role: string | null | undefined): string => {
  switch (role) {
    case 'Senior Tech':
    case 'Senior Event Technician': return 'Senior Event Technician';
    case 'Junior Tech':
    case 'Event Technician': return 'Event Technician';
    case 'Attendant':
    case 'Event Attendant': return 'Event Attendant';
    default: return role || '';
  }
};

export const STAFF_ROLE_OPTIONS = [
  'Admin', 'Event Attendant', 'Event Technician', 'Senior Event Technician',
  'Equipment Manager', 'Event Manager', 'Photographer',
];

export const OPERATIONAL_ROLES = ['Senior Event Technician', 'Event Technician', 'Event Attendant'];
